import { UserOfProject } from "./usersOfProject.modal";

/**
 * 내부용 admin 계정은 고객 UI 에 노출하지 않는다 (issue-system#428).
 * 여기(select)가 멤버 목록의 유일한 공급 지점이라 행·카운트·patch·삭제가 모두 필터를 따른다.
 *
 * 필터 결과 0건은 `[]` 로 남긴다 — 예전처럼 `undefined` 로 접으면 "필터 결과 0건"이
 * "아직 도착하지 않음/조회 실패"와 같은 값이 되어 소비처가 둘을 구별할 수 없다.
 * 조회 실패는 경계 승격으로 이미 `isError` 로만 나타난다.
 */
export const selectVisibleUsers = (users: UserOfProject[]): UserOfProject[] =>
  users.filter((user) => !user.is_admin);
